module.exports = __webpack_public_path__ + "img/CPT04.447d93cb.svg";